import { getMessages } from '../../../../../../store/constants';

export const COPY_CARD_BUTTON_TITLE = getMessages().getText('card_form_copy_card_button');
export const COPY_CARD_BUTTON_TOOLTIP = getMessages().getText('card_form_copy_card_tooltip');
